import Scenario1Part1 from './Scenario1Part1';
import Scenario1Part2 from './Scenario1Part2';
import Scenario1Part3 from './Scenario1Part3';
import Scenario1Part4 from './Scenario1Part4';
import Scenario1Part5 from './Scenario1Part5';
import Scenario1Part6 from './Scenario1Part6';
import Scenario1Part7 from './Scenario1Part7';
import Scenario1Part8 from './Scenario1Part8';
import GameManager from '../../cvp-webgames-core/GameManager';
import { constants } from '../../misc/constants';
import BaseScenarioPart from '../../cvp-webgames-core/Scenario/BaseScenarioPart';
import { VideoEnvironmentProps } from '../../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
import { MedsurgBaseScenario, ScenarioData } from '../MedsurgBaseScenario';

export default class Scenario1 extends MedsurgBaseScenario {
	public PrHolderID: string;
	public PrMcID: string;
	public PrFellowID: string;
	public PrJonesID: string;
	public holderVitalsID: string = 'holderVitals';
	public holderNursesID: string = 'holderNurses';
	public holderBasicID: string = 'holderBasic';
	public mcVitalsID: string = 'mcVitals';
	public mcNursesID: string = 'mcNurses';
	public mcBasicID: string = 'mcBasic';
	public fellowVitalsID: string = 'fellowVitals';
	public fellowNursesID: string = 'fellowNurses';
	public fellowBasicID: string = 'fellowBasic';
	public jonesVitalsID: string = 'jonesVitals';
	public jonesNursesID: string = 'jonesNurses';
	public jonesBasicID: string = 'jonesBasic';
	public scenarioData: ScenarioData = {
		entries: [{
			id: this.holderVitalsID,
			items: []
		},
		{
			id: this.holderNursesID,
			items: []
		},
		{
			id: this.holderBasicID,
			items: []
		},
		{
			id: this.mcVitalsID,
			items: []
		},
		{
			id: this.mcNursesID,
			items: []
		},
		{
			id: this.mcBasicID,
			items: []
		},
		{
			id: this.fellowVitalsID,
			items: []
		},
		{
			id: this.fellowNursesID,
			items: []
		},
		{
			id: this.fellowBasicID,
			items: []
		},
		{
			id: this.jonesVitalsID,
			items: []
		},
		{
			id: this.jonesNursesID,
			items: []
		},
		{
			id: this.jonesBasicID,
			items: []
		}]
	};

	public getScenarioData(): ScenarioData {
		return this.scenarioData;
	};
	public setScenarioData(data: ScenarioData): void {
		this.scenarioData = data;
	};

	parts: BaseScenarioPart<MedsurgBaseScenario>[] = [
		new Scenario1Part1(this, () => {this.goToPart2()}),
		new Scenario1Part2(this, () => {this.goToPart3()}),
		new Scenario1Part3(this, () => {this.goToPart4()}),
		new Scenario1Part4(this, () => {this.goToPart5()}),
		new Scenario1Part5(this, () => {this.goToPart6()}),
		new Scenario1Part6(this, () => {this.goToPart7()}),
		new Scenario1Part7(this, () => {this.goToPart8()}),
		new Scenario1Part8(this, () => {this.goToScenarioEnd()})
	]
	public get totalNumberOfQuestions(): number {
		return 5;
	}
	
	public getEnviromentProps(): VideoEnvironmentProps {
		return {
			controls: true
		};
	}
	
    public get currentLevel(): number {
        return 0;
    }

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
	}

	public getParts(): BaseScenarioPart<MedsurgBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return './assets/audio/scenario1/' + fileName + '.mp3';
	}

	start() {
		this.gameManager.UiManager.createUIInstance(constants.uiNames.SplashScreenUI);
		this.goToPart1();
	}

	goToPart1() {
		this.loadPart(constants.scenarios.scenario1.parts.level1Part1.id, () => {
			this.destroyAllUIInstances();
        });
	}

	goToPart2() {
		this.loadPart(constants.scenarios.scenario1.parts.level1Part2.id);
	}

	goToPart3() {
		this.loadPart(constants.scenarios.scenario1.parts.level1Part3.id);
	}

	goToPart4() {
		this.loadPart(constants.scenarios.scenario1.parts.level1Part4.id);
	}

	goToPart5() {
		this.loadPart(constants.scenarios.scenario1.parts.level1Part5.id);
	}

	goToPart6() {
		this.loadPart(constants.scenarios.scenario1.parts.level1Part6.id);
	}

	goToPart7() {
		this.loadPart(constants.scenarios.scenario1.parts.level1Part7.id);
	}

	goToPart8() {
		this.loadPart(constants.scenarios.scenario1.parts.level1Part8.id);
	}

	goToScenarioEnd() {
	}
}